module.exports = __webpack_public_path__ + "img/step2.6da3a7c7.png";